export enum DealerTabsEnum {
  'Not Submitted' = 1,
  'Submitted',
  'Approved Acknowledgements',
  'All Orders',
}
